import { useState } from 'react'
import { FileUpload, Loader, type FileWithType } from '~/shared/ui'
import { Button, Typography, Box } from '@mui/material'
import { uploadPracticeSuiteInvoice } from './PracticeSuiteService'
import { useMutation } from '~/shared/hooks/useMutation'

const PracticeSuiteInvoiceSettings = () => {
  const [file, setFile] = useState<FileWithType | null>(null)
  const [uploadKey, setUploadKey] = useState<number>(0)
  const handleRemoveAttachment = () => {
    setFile(null)
    setUploadKey(uploadKey + 1)
  }

  const { run: uploadFile, loading: sending } = useMutation(
    async () => {
      if (!file) return
      const data = new FormData()
      data.append('file', file.data)
      data.append('title', file.data.name)
      try {
        await uploadPracticeSuiteInvoice(data)
      } finally {
        // Cleared either way: a failed upload should not leave the same file queued for a retry.
        handleRemoveAttachment()
      }
      // The success notification keys off a defined result.
      return true
    },
    { success: 'Successfully uploaded file.', error: 'Unable to upload file.' },
  )

  return (
    <Box sx={{ p: '16px' }}>
      <Typography variant="h6">Upload Practice Suite Invoice</Typography>
      <Typography>Select file</Typography>
      <Box>
        <FileUpload
          disabled={sending}
          file={null}
          key={uploadKey}
          handleFile={fileWithType => setFile(fileWithType)}
          handleClear={() => setUploadKey(uploadKey + 1)}
          supportedImageTypes={[]}
          supportedDocTypes={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
          supportMessage="Supports Excel Documents Only"
        />
      </Box>
      {file && <Typography>{file.data.name}</Typography>}
      <Button color="primary" onClick={uploadFile} disabled={!file || sending}>
        {sending ? <Loader inline /> : 'Upload'}
      </Button>
    </Box>
  )
}

export default PracticeSuiteInvoiceSettings
